import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import {
  loginSelector,
  onLogout,
  setLocalLogout,
} from '../../features/loginSlice';
import { toast } from 'react-toastify';
import { useMsal } from '@azure/msal-react';
import CenterSpinner from '../../components/CenterSpinner';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';

const SettingPage: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const logout = useAppSelector(loginSelector).logout;

  useEffect(() => {
    if (logout) {
      setShowLoader(false);
      toast.success(logout.responseMessage);
      dispatch(setLocalLogout());
      instance.logoutRedirect();
    }
  }, [logout]);

  const callLogout = () => {
    setShowLoader(true);
    dispatch(onLogout());
  };
  return (
    <div className="d-flex justify-content-center wh-100">
      <div>
        <Button variant="primary" onClick={callLogout}>
          Logout
        </Button>
      </div>
      <CenterSpinner showLoader={showLoader} className="spinner-style" />
    </div>
  );
};

export default SettingPage;
